"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.simpleConfigStubFile = exports.defaultConfigStubFile = exports.defaultConfigFile = exports.cli = void 0;

var _path = _interopRequireDefault(require("path"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const cli = 'tailwind';
exports.cli = cli;
const defaultConfigFile = './tailwind.config.js';
exports.defaultConfigFile = defaultConfigFile;

const defaultConfigStubFile = _path.default.resolve(__dirname, '../stubs/defaultConfig.stub.js');

exports.defaultConfigStubFile = defaultConfigStubFile;

const simpleConfigStubFile = _path.default.resolve(__dirname, '../stubs/simpleConfig.stub.js');

exports.simpleConfigStubFile = simpleConfigStubFile;